<template>
    <div class="flex flex-col gap-5 rounded-lgr border border-valence-grey-250 bg-white px-6 py-4 sm:px-10 sm:py-7" data-test-id="perspective-nudge-card">
        <h3 class="display-small-serif text-valence-stone-900">Make each insight more relevant to you</h3>

        <div class="border-t border-valence-grey-250"></div>

        <div class="flex flex-col gap-3">
            <h4 class="scaffold-body-small-medium text-valence-stone-900">Insight strength</h4>
            <div class="insight-strength-track" role="img" :aria-label="insightStrengthAriaLabel">
                <span class="insight-strength-perspective" :style="{ width: `${WITH_PERSPECTIVE_PERCENT}%` }"></span>
                <span class="insight-strength-calendar" :style="{ width: `${CALENDAR_ONLY_PERCENT}%` }"></span>
            </div>
            <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
                <span class="details flex items-center gap-2 whitespace-nowrap text-valence-stone-700">
                    <span class="insight-strength-dot bg-[#bd3e7a]" aria-hidden="true"></span>
                    Calendar only
                </span>
                <span class="details flex items-center gap-2 whitespace-nowrap text-valence-stone-700">
                    <span class="insight-strength-dot bg-[#eaa9c4]" aria-hidden="true"></span>
                    With your Perspective
                </span>
            </div>
        </div>

        <div class="flex flex-col gap-1.5 rounded-lg bg-valence-cream-50 p-5">
            <p class="body-small-bold text-valence-stone-900">Why it’s worth the 10 minutes</p>
            <p class="body-small text-valence-stone-700">Perspective captures how you work best, helping Nadia focus on what matters to you.</p>
        </div>

        <BaseButton theme="primary" class="w-full bg-[#3b3b3b] hover:bg-valence-grey-800" data-test-id="perspective-nudge-cta" @click="emit('cta-click')">
            Complete your Perspective
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";

const CALENDAR_ONLY_PERCENT = 34;
const WITH_PERSPECTIVE_PERCENT = 82.5;
const insightStrengthAriaLabel = `Insight strength: ${CALENDAR_ONLY_PERCENT}% with calendar only, ${Math.round(WITH_PERSPECTIVE_PERCENT)}% with your Perspective completed`;

const emit = defineEmits<{
    "cta-click": [];
}>();

onMounted(() => {
    logUserInteraction(AmplitudeEventNames.MYWORK_PERSPECTIVE_NUDGE_CARD_SHOWN);
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .insight-strength-track {
        @apply relative h-3.5 w-full rounded-full bg-[#f0ede8];
    }
    .insight-strength-perspective {
        @apply absolute inset-y-0 left-0 rounded-full bg-[#eaa9c4];
    }
    .insight-strength-calendar {
        @apply absolute inset-y-0 left-0 rounded-full bg-[#bd3e7a];
    }
    .insight-strength-dot {
        @apply size-2 shrink-0 rounded-full;
    }
}
</style>
